import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Face as FaceIcon } from '@mui/icons-material';
import { Avatar, Popover, MenuList, MenuItem, ClickAwayListener } from '@mui/material';
import './UserInfo.css';

class UserInfo extends PureComponent {
  constructor() {
    super();

    this.state = {
      open: false,
      anchorEl: null,
    };

    this._onClick = this._onClick.bind(this);
    this._onRequestClose = this._onRequestClose.bind(this);
  }

  render() {
    return (
      <div className="user-info u-pv-half" data-qa="qa-user-info">
        <div className="u-fx u-fx-align-center">
          <div className="u-mr-full u-fx u-fx-column u-fx-align-start">
            <p className="u-bold">{this.props.username}</p>
            <p className="u-italic u-smallFont">{this.props.role}</p>
          </div>
          {this.props.avatarUrl ? (
            <Avatar
              src={this.props.avatarUrl}
              onClick={this._onClick}
              aria-owns={this.state.open ? 'user-menu-list' : undefined}
              aria-haspopup="true"
              data-qa="qa-user-logo"
            />
          ) : (
            <Avatar
              onClick={this._onClick}
              aria-owns={this.state.open ? 'user-menu-list' : undefined}
              aria-haspopup="true"
              data-qa="qa-user-logo"
            >
              <FaceIcon />
            </Avatar>
          )}
        </div>
        <Popover
          id="user-menu-list"
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'right', vertical: 'top' }}
        >
          <ClickAwayListener onClickAway={this._onRequestClose}>
            <MenuList>
              <MenuItem
                onClick={this.props.onClickChangePasswordOption}
                data-qa="qa-user-change-password"
              >
                Change password
              </MenuItem>
              <MenuItem onClick={this.props.onClickLogoutOption} data-qa="qa-user-log-out">
                {' '}
                Log out{' '}
              </MenuItem>
            </MenuList>
          </ClickAwayListener>
        </Popover>
      </div>
    );
  }

  _onClick(e) {
    e.preventDefault();
    this.setState({
      open: true,
      anchorEl: e.currentTarget,
    });
  }

  _onRequestClose() {
    this.setState({ anchorEl: null, open: false });
  }
}

UserInfo.propTypes = {
  username: PropTypes.string,
  role: PropTypes.string,
  onClickLogoutOption: PropTypes.func,
  onClickChangePasswordOption: PropTypes.func,
  avatarUrl: PropTypes.string,
};

UserInfo.defaultProps = {
  username: '',
  role: 'User',
  onClickLogoutOption: () => {},
  onClickChangePasswordOption: () => {},
  avatarUrl: '',
};

export default UserInfo;
